export enum GTM_CUSTOM_TAG {
  ENTER_SITE = 'enter_endtherig_com',
  VIEW_CONTENT = 'view_content',
  CLICK_PLAY_BUTTON = 'click_play_button',
  COMPLETE_REGISTRATION = 'complete_registration',
  OPEN_UNREAL_GAME = 'open_unreal_game',
  DOWNLOAD_GAME = 'download_game',
}
